import Vue from "vue";
import Router from "vue-router";
import Main from "@/components/Main.vue";
import Home from "@/components/Home.vue";
import publicRoutes from "./public";
import {
  verifyToken,
  patientRouteGuard,
  trackPage,
  conditionalRoute,
} from "./navigation-guard";
import patientRoutes from "./patient";
import dashboardRoutes from "./dashboard";
import dashboardAlertsRoutes from "./followups";
import treatmentRoutes from "./treatment";
import userRoutes from "./user";
import profileRoutes from "./profile";
import indicationRoutes from "./indication";
import appointmentRoutes from "./appointment";
import settingsRoutes from "./settings";
import paymentRoutes from "./payment";
import validationRoutes from "./validation";
import prescriptionRoutes from "./prescription";
import contractsRoutes from "./contracts";
import administrationRoutes from "./administration";
import memberRoutes from "./members";
import providerRoutes from "./providers";
import claimRoutes from "./claims";
import planRoutes from "./plans";
import pharmacyRoutes from "./pharmacies";
import authorizationRoutes from "./authorization";
import auditRoutes from "./audit";
import platformRoutes from "./platform";
import reportsRoutes from "./reports";

Vue.use(Router);

const router = new Router({
  mode: "history",
  linkActiveClass: "is-active",
  routes: [
    ...publicRoutes,
    {
      path: "/",
      component: Main,
      children: [
        {
          path: "/",
          name: "home",
          component: Home,
        },
        ...dashboardAlertsRoutes,
        ...dashboardRoutes,
        ...patientRoutes,
        ...treatmentRoutes,
        ...userRoutes,
        ...profileRoutes,
        ...indicationRoutes,
        ...appointmentRoutes,
        ...settingsRoutes,
        ...paymentRoutes,
        ...validationRoutes,
        ...prescriptionRoutes,
        ...contractsRoutes,
        ...administrationRoutes,
        ...memberRoutes,
        ...providerRoutes,
        ...claimRoutes,
        ...planRoutes,
        ...pharmacyRoutes,
        ...authorizationRoutes,
        ...auditRoutes,
        ...platformRoutes,
        ...reportsRoutes,
      ],
    },
  ],
});

router.beforeEach(verifyToken);
router.beforeEach(patientRouteGuard);
router.beforeEach(trackPage);
router.beforeEach(conditionalRoute);

export default router;
